<template>
  <b-modal
    id="modal_form"
    size="lg"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <label><strong>Detalhes</strong></label>
        </b-row>
        <b-row no-gutters>
          <b-col sm="2" md="2" class="m-t-5px p-a-0">
            <label>Tipo *</label>
            <multiselect
              v-model="tpDocSelected"
              :options="this.$parent.optionsTpDocFiscal"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('tp_doc.value')"
              v-if="helpForm.errors.has('tp_doc.value')"
            ></b-form-feedback>
          </b-col>

          <b-col sm="1" md="1" class="m-t-5px p-a-0">
            <label>Nº Fiscal *</label>
            <b-form-input
              type="text"
              placeholder="Nº Fiscal"
              v-model="helpForm.num_fiscal"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('num_fiscal')"
              v-if="helpForm.errors.has('num_fiscal')"
            ></b-form-feedback>
          </b-col>

          <b-col sm="1" md="1" class="m-t-5px p-a-0">
            <label>Série *</label>
            <b-form-input
              type="text"
              placeholder="Série"
              v-model="helpForm.serie"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('serie')"
              v-if="helpForm.errors.has('serie')"
            ></b-form-feedback>
          </b-col>

          <b-col sm="1" md="1" class="m-t-5px p-a-0">
            <label>Chave</label>
            <b-form-input
              type="text"
              placeholder="Chave"
              v-model="helpForm.chave"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('chave')"
              v-if="helpForm.errors.has('chave')"
            ></b-form-feedback>
          </b-col>

          <b-col sm="2" md="2" class="m-t-5px p-a-0">
            <label>Data *</label>
            <input
              type="text"
              placeholder="Data"
              class="form-control"
              v-mask="'##/##/####'"
              v-model="helpForm.dt_emissao"
              @keyup.enter="doFilter"
            />
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('dt_emissao')"
              v-if="helpForm.errors.has('dt_emissao')"
            ></b-form-feedback>
          </b-col>

          <b-col sm="1" md="1" class="m-t-5px p-a-0">
            <label>Volume *</label>
            <b-form-input
              type="text"
              placeholder="Volume"
              v-model="helpForm.qtd_volume"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('qtd_volume')"
              v-if="helpForm.errors.has('qtd_volume')"
            ></b-form-feedback>
          </b-col>

          <b-col sm="2" md="2" class="m-t-5px p-a-0">
            <label>Peso Bruto *</label>
            <b-form-input
                type="text"
                placeholder="Volume"
                v-model="helpForm.peso_bruto"
            >
            </b-form-input>
<!--            <currency-input-->
<!--              class="form-control"-->
<!--              v-model="helpForm.peso_bruto"-->
<!--              placeholder=""-->
<!--              :precision="3"-->
<!--              locale="de-DE"-->
<!--              style="text-align: right"-->
<!--              :currency="{ prefix: 'KG ' }"-->
<!--              :distraction-free="getCurrency"-->
<!--            />-->
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('peso_bruto')"
              v-if="helpForm.errors.has('peso_bruto')"
            ></b-form-feedback>
          </b-col>

          <b-col sm="2" md="2" class="m-t-5px p-a-0">
            <label>Valor Doc. *</label>
            <currency-input
              class="form-control"
              v-model="helpForm.vlr_total_nfe"
              placeholder=""
              :auto-decimal-mode="true"
              :locale="getCurrency.locale"
              style="text-align: right"
              :currency="{ prefix: 'R$ ' }"
              :distraction-free="getCurrency"
            />
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('vlr_total_nfe')"
              v-if="helpForm.errors.has('vlr_total_nfe')"
            ></b-form-feedback>
          </b-col>
          <b-col sm="2" md="3" class="m-t-5px p-a-0">
            <label>Modalidade de Frete</label>
            <multiselect
              v-model="modalidadeSelected"
              :options="this.$parent.optionsModalidadeFrete"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('tp_doc.value')"
              v-if="helpForm.errors.has('tp_doc.value')"
            ></b-form-feedback>
          </b-col>
          <b-col sm="2" md="3" class="m-t-5px p-a-0">
            <label>Tipo de Carga</label>
            <multiselect
              v-model="tipoCargaSelected"
              :options="this.$parent.optionsTipoCarga"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('tipo_carga')"
              v-if="helpForm.errors.has('tipo_carga')"
            ></b-form-feedback>
          </b-col>
          <b-col sm="2" md="3" class="m-t-5px p-a-0">
            <label>N° de Lote</label>
            <b-form-input
              type="text"
              placeholder="N° de Lote"
              v-model="helpForm.num_lote"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="helpForm.errors.get('num_lote')"
              v-if="helpForm.errors.has('num_lote')"
            ></b-form-feedback>
          </b-col>
        </b-row>
        <b-tabs style="margin: 10px 0">
          <b-tab title="Emitente Documento" active>
            <b-row no-gutters>
              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>Tipo *</label>
                <b-form-group>
                  <b-form-radio-group
                    v-model="helpForm.emi_tp_pessoa"
                    :options="this.$parent.optionsTpPessoa"
                    plain
                    @input="ajustaMascara(1, 1)"
                  ></b-form-radio-group>
                  <!--AjustaMascara(emitente/destinatario, nfe/cte)-->
                </b-form-group>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('emi_tp_pessoa')"
                  v-if="helpForm.errors.has('emi_tp_pessoa')"
                ></b-form-feedback>
              </b-col>

              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>CNPJ/CPF</label>
                <b-form-input
                  type="text"
                  placeholder="CNPJ/CPF"
                  v-mask="mascaraEmiNfe"
                  v-model="helpForm.emi_cnpj_cpf_cuit"
                  @input="
                    helpForm.emi_cnpj_cpf_cuit = sanitizeDocPessoa(
                      helpForm.emi_cnpj_cpf_cuit
                    )
                  "
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('emi_cnpj_cpf_cuit')"
                  v-if="helpForm.errors.has('emi_cnpj_cpf_cuit')"
                ></b-form-feedback>
              </b-col>
              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>IE</label>
                <b-form-input
                  type="text"
                  placeholder="IE"
                  v-model="helpForm.emi_ie"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('emi_ie')"
                  v-if="helpForm.errors.has('emi_ie')"
                ></b-form-feedback>
              </b-col>
              <b-col sm="6" md="6" class="m-t-5px p-a-0">
                <label>Nome</label>
                <b-form-input
                  type="text"
                  placeholder="Nome"
                  v-model="helpForm.emi_nome"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('emi_nome')"
                  v-if="helpForm.errors.has('emi_nome')"
                ></b-form-feedback>
              </b-col>
            </b-row>
            <div class="loadingDataPositionEndereco">
              <div class="loadingData" v-if="loadingCepEmi">
                <div class="loadingDataSpinner">
                  <spinner
                    v-if="loadingCepEmi"
                    text-fg-color="#ffffff"
                    message="Carregando..."
                  ></spinner>
                </div>
              </div>
              <b-row no-gutters>
                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>CEP *</label>
                  <b-form-input
                    type="text"
                    placeholder="CEP"
                    @change="getCep(1)"
                    v-model="helpForm.emi_cep"
                    v-mask="'##.###-###'"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('emi_cep')"
                    v-if="helpForm.errors.has('emi_cep')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>Municipio *</label>
                  <multiselect
                    v-model="emiMunicipioSelected"
                    :options="this.$parent.optionsMunicipios"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('emi_municipio.value')"
                    v-if="helpForm.errors.has('emi_municipio.value')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Uf *</label>
                  <multiselect
                    v-model="emiUfSelected"
                    :options="this.$parent.optionsUf"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label=""
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('emi_uf.value')"
                    v-if="helpForm.errors.has('emi_uf.value')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="3" md="3" class="m-t-5px p-a-0">
                  <label>Endereço *</label>
                  <b-form-input
                    type="text"
                    placeholder="Endereço"
                    v-model="helpForm.emi_endereco"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('emi_endereco')"
                    v-if="helpForm.errors.has('emi_endereco')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Número *</label>
                  <b-form-input
                    type="text"
                    placeholder="Número"
                    v-model="helpForm.emi_numero"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('emi_numero')"
                    v-if="helpForm.errors.has('emi_numero')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Bairro *</label>
                  <b-form-input
                    type="text"
                    placeholder="Bairro"
                    v-model="helpForm.emi_bairro"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('emi_bairro')"
                    v-if="helpForm.errors.has('emi_bairro')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>Complemento</label>
                  <b-form-input
                    type="text"
                    placeholder="Complemento"
                    v-model="helpForm.emi_complemento"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('emi_complemento')"
                    v-if="helpForm.errors.has('emi_complemento')"
                  ></b-form-feedback>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Destinatário Documento">
            <b-row no-gutters>
              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>Tipo *</label>
                <b-form-group>
                  <b-form-radio-group
                    v-model="helpForm.des_tp_pessoa"
                    :options="this.$parent.optionsTpPessoa"
                    plain
                    @input="ajustaMascara(2, 1)"
                  ></b-form-radio-group>
                  <!--AjustaMascara(emitente/destinatario, nfe/cte)-->
                </b-form-group>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('des_tp_pessoa')"
                  v-if="helpForm.errors.has('des_tp_pessoa')"
                ></b-form-feedback>
              </b-col>

              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>CNPJ/CPF</label>
                <b-form-input
                  type="text"
                  placeholder="CNPJ/CPF"
                  v-mask="mascaraDesNfe"
                  v-model="helpForm.des_cnpj_cpf_cuit"
                  @input="
                    helpForm.des_cnpj_cpf_cuit = sanitizeDocPessoa(
                      helpForm.des_cnpj_cpf_cuit
                    )
                  "
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('des_cnpj_cpf_cuit')"
                  v-if="helpForm.errors.has('des_cnpj_cpf_cuit')"
                ></b-form-feedback>
              </b-col>
              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>IE</label>
                <b-form-input
                  type="text"
                  placeholder="IE"
                  v-model="helpForm.des_ie"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('des_ie')"
                  v-if="helpForm.errors.has('des_ie')"
                ></b-form-feedback>
              </b-col>
              <b-col sm="4" md="4" class="m-t-5px p-a-0">
                <label>Nome</label>
                <b-form-input
                  type="text"
                  placeholder="Nome"
                  v-model="helpForm.des_nome"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('des_nome')"
                  v-if="helpForm.errors.has('des_nome')"
                ></b-form-feedback>
              </b-col>
              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>PIN Suframa</label>
                <b-form-input
                  type="text"
                  placeholder="PIN"
                  v-model="helpForm.des_pin"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('des_pin')"
                  v-if="helpForm.errors.has('des_pin')"
                ></b-form-feedback>
              </b-col>
            </b-row>
            <div class="loadingDataPositionEndereco">
              <div class="loadingData" v-if="loadingCepDes">
                <div class="loadingDataSpinner">
                  <spinner
                    v-if="loadingCepDes"
                    text-fg-color="#ffffff"
                    message="Carregando..."
                  ></spinner>
                </div>
              </div>
              <b-row no-gutters>
                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>CEP *</label>
                  <b-form-input
                    type="text"
                    placeholder="CEP"
                    @change="getCepDes(2)"
                    v-model="helpForm.des_cep"
                    v-mask="'##.###-###'"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('des_cep')"
                    v-if="helpForm.errors.has('des_cep')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>Municipio *</label>
                  <multiselect
                    v-model="desMunicipioSelected"
                    :options="this.$parent.optionsMunicipios"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('des_municipio.value')"
                    v-if="helpForm.errors.has('des_municipio.value')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Uf *</label>
                  <multiselect
                    v-model="desUfSelected"
                    :options="this.$parent.optionsUf"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label=""
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('des_uf.value')"
                    v-if="helpForm.errors.has('des_uf.value')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="3" md="3" class="m-t-5px p-a-0">
                  <label>Endereço *</label>
                  <b-form-input
                    type="text"
                    placeholder="Endereço"
                    v-model="helpForm.des_endereco"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('des_endereco')"
                    v-if="helpForm.errors.has('des_endereco')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Número *</label>
                  <b-form-input
                    type="text"
                    placeholder="Número"
                    v-model="helpForm.des_numero"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('des_numero')"
                    v-if="helpForm.errors.has('des_numero')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Bairro *</label>
                  <b-form-input
                    type="text"
                    placeholder="Bairro"
                    v-model="helpForm.des_bairro"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('des_bairro')"
                    v-if="helpForm.errors.has('des_bairro')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>Complemento</label>
                  <b-form-input
                    type="text"
                    placeholder="Complemento"
                    v-model="helpForm.des_complemento"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('des_complemento')"
                    v-if="helpForm.errors.has('des_complemento')"
                  ></b-form-feedback>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Redespacho">
            <b-row no-gutters>
              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>Tipo *</label>
                <b-form-group>
                  <b-form-radio-group
                    v-model="helpForm.red_tp_pessoa"
                    :options="this.$parent.optionsTpPessoa"
                    plain
                    @input="ajustaMascara(3, 1)"
                  ></b-form-radio-group>
                  <!--AjustaMascara(emitente/destinatario, nfe/cte)-->
                </b-form-group>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('red_tp_pessoa')"
                  v-if="helpForm.errors.has('red_tp_pessoa')"
                ></b-form-feedback>
              </b-col>

              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>CNPJ/CPF</label>
                <b-form-input
                  type="text"
                  placeholder="CNPJ/CPF"
                  v-mask="mascaraRedNfe"
                  v-model="helpForm.red_cnpj_cpf_cuit"
                  @input="
                    helpForm.red_cnpj_cpf_cuit = sanitizeDocPessoa(
                      helpForm.red_cnpj_cpf_cuit
                    )
                  "
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('red_cnpj_cpf_cuit')"
                  v-if="helpForm.errors.has('red_cnpj_cpf_cuit')"
                ></b-form-feedback>
              </b-col>
              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>IE</label>
                <b-form-input
                  type="text"
                  placeholder="IE"
                  v-model="helpForm.red_ie"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('red_ie')"
                  v-if="helpForm.errors.has('red_ie')"
                ></b-form-feedback>
              </b-col>
              <b-col sm="4" md="4" class="m-t-5px p-a-0">
                <label>Nome</label>
                <b-form-input
                  type="text"
                  placeholder="Nome"
                  v-model="helpForm.red_nome"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('red_nome')"
                  v-if="helpForm.errors.has('red_nome')"
                ></b-form-feedback>
              </b-col>
            </b-row>
            <div class="loadingDataPositionEndereco">
              <div class="loadingData" v-if="loadingCepDes">
                <div class="loadingDataSpinner">
                  <spinner
                    v-if="loadingCepDes"
                    text-fg-color="#ffffff"
                    message="Carregando..."
                  ></spinner>
                </div>
              </div>
              <b-row no-gutters>
                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>CEP *</label>
                  <b-form-input
                    type="text"
                    placeholder="CEP"
                    @change="getCepRed(2)"
                    v-model="helpForm.red_cep"
                    v-mask="'##.###-###'"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('red_cep')"
                    v-if="helpForm.errors.has('red_cep')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>Municipio *</label>
                  <multiselect
                    v-model="redMunicipioSelected"
                    :options="this.$parent.optionsMunicipios"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('red_municipio.value')"
                    v-if="helpForm.errors.has('red_municipio.value')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Uf *</label>
                  <multiselect
                    v-model="redUfSelected"
                    :options="this.$parent.optionsUf"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label=""
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('red_uf.value')"
                    v-if="helpForm.errors.has('red_uf.value')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="3" md="3" class="m-t-5px p-a-0">
                  <label>Endereço *</label>
                  <b-form-input
                    type="text"
                    placeholder="Endereço"
                    v-model="helpForm.red_endereco"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('red_endereco')"
                    v-if="helpForm.errors.has('red_endereco')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Número *</label>
                  <b-form-input
                    type="text"
                    placeholder="Número"
                    v-model="helpForm.red_numero"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('red_numero')"
                    v-if="helpForm.errors.has('red_numero')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Bairro *</label>
                  <b-form-input
                    type="text"
                    placeholder="Bairro"
                    v-model="helpForm.red_bairro"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('red_bairro')"
                    v-if="helpForm.errors.has('red_bairro')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>Complemento</label>
                  <b-form-input
                    type="text"
                    placeholder="Complemento"
                    v-model="helpForm.red_complemento"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('red_complemento')"
                    v-if="helpForm.errors.has('red_complemento')"
                  ></b-form-feedback>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Tomador">
            <b-row no-gutters>
              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>Tipo *</label>
                <b-form-group>
                  <b-form-radio-group
                    v-model="helpForm.tom_tp_pessoa"
                    :options="this.$parent.optionsTpPessoa"
                    plain
                    @input="ajustaMascara(4, 1)"
                  ></b-form-radio-group>
                  <!--AjustaMascara(emitente/destinatario, nfe/cte)-->
                </b-form-group>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('tom_tp_pessoa')"
                  v-if="helpForm.errors.has('tom_tp_pessoa')"
                ></b-form-feedback>
              </b-col>

              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>CNPJ/CPF</label>
                <b-form-input
                  type="text"
                  placeholder="CNPJ/CPF"
                  v-mask="mascaraTomNfe"
                  v-model="helpForm.tom_cnpj_cpf_cuit"
                  @input="
                    helpForm.tom_cnpj_cpf_cuit = sanitizeDocPessoa(
                      helpForm.tom_cnpj_cpf_cuit
                    )
                  "
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('tom_cnpj_cpf_cuit')"
                  v-if="helpForm.errors.has('tom_cnpj_cpf_cuit')"
                ></b-form-feedback>
              </b-col>
              <b-col sm="2" md="2" class="m-t-5px p-a-0">
                <label>IE</label>
                <b-form-input
                  type="text"
                  placeholder="IE"
                  v-model="helpForm.tom_ie"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('tom_ie')"
                  v-if="helpForm.errors.has('tom_ie')"
                ></b-form-feedback>
              </b-col>
              <b-col sm="4" md="4" class="m-t-5px p-a-0">
                <label>Nome</label>
                <b-form-input
                  type="text"
                  placeholder="Nome"
                  v-model="helpForm.tom_nome"
                >
                </b-form-input>
                <b-form-feedback
                  class="text-danger"
                  v-text="helpForm.errors.get('tom_nome')"
                  v-if="helpForm.errors.has('tom_nome')"
                ></b-form-feedback>
              </b-col>
            </b-row>
            <div class="loadingDataPositionEndereco">
              <div class="loadingData" v-if="loadingCepDes">
                <div class="loadingDataSpinner">
                  <spinner
                    v-if="loadingCepDes"
                    text-fg-color="#ffffff"
                    message="Carregando..."
                  ></spinner>
                </div>
              </div>
              <b-row no-gutters>
                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>CEP *</label>
                  <b-form-input
                    type="text"
                    placeholder="CEP"
                    @change="getCepTom(2)"
                    v-model="helpForm.tom_cep"
                    v-mask="'##.###-###'"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('tom_cep')"
                    v-if="helpForm.errors.has('tom_cep')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>Municipio *</label>
                  <multiselect
                    v-model="tomMunicipioSelected"
                    :options="this.$parent.optionsMunicipios"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('tom_municipio.value')"
                    v-if="helpForm.errors.has('tom_municipio.value')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Uf *</label>
                  <multiselect
                    v-model="tomUfSelected"
                    :options="this.$parent.optionsUf"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label=""
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('tom_uf.value')"
                    v-if="helpForm.errors.has('tom_uf.value')"
                  ></b-form-feedback>
                </b-col>


                <b-col sm="3" md="3" class="m-t-5px p-a-0">
                  <label>Endereço *</label>
                  <b-form-input
                    type="text"
                    placeholder="Endereço"
                    v-model="helpForm.tom_endereco"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('tom_endereco')"
                    v-if="helpForm.errors.has('tom_endereco')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Número *</label>
                  <b-form-input
                    type="text"
                    placeholder="Número"
                    v-model="helpForm.tom_numero"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('tom_numero')"
                    v-if="helpForm.errors.has('tom_numero')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="1" md="1" class="m-t-5px p-a-0">
                  <label>Bairro *</label>
                  <b-form-input
                    type="text"
                    placeholder="Bairro"
                    v-model="helpForm.tom_bairro"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('tom_bairro')"
                    v-if="helpForm.errors.has('tom_bairro')"
                  ></b-form-feedback>
                </b-col>

                <b-col sm="2" md="2" class="m-t-5px p-a-0">
                  <label>Complemento</label>
                  <b-form-input
                    type="text"
                    placeholder="Complemento"
                    v-model="helpForm.tom_complemento"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="helpForm.errors.get('tom_complemento')"
                    v-if="helpForm.errors.has('tom_complemento')"
                  ></b-form-feedback>
                </b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
        <div v-if="this.item.length == 0">
          <label><strong>Item</strong></label>
          <i
            class="fa fa-plus-square"
            v-on:click="addRow()"
            v-b-tooltip.hover.right="'Adicionar Item'"
            style="cursor: pointer"
          ></i>
        </div>
        <div v-for="(row, index_item) in item" style="display: flex; flex-direction: row">
          <div style="display: flex; flex-direction: column">
            <label><strong>Item</strong></label>
            <i
              class="fa fa-plus-square"
              v-on:click="addRow(row.num_item)"
              v-b-tooltip.hover.right="'Adicionar Item'"
              style="cursor: pointer"
            ></i>
            <i
              v-if="index_item !== 0"
              class="fa fa-times"
              style="cursor: pointer"
              v-b-tooltip.hover.right="'Remover Item'"
              v-on:click="removeRow(index_item)"
            ></i>
          </div>
          <b-col style="padding: 0">
            <label>Cód</label>
            <b-form-input
              type="text"
              placeholder="Cód"
              v-model="row.cd_produto"
            >
            </b-form-input>
          </b-col>
          <b-col style="padding: 0">
            <label>Descrição</label>
            <b-form-input
              type="text"
              placeholder="Descrição"
              v-model="row.descr_produto"
            >
            </b-form-input>
          </b-col>
          <b-col style="padding: 0">
            <label>NCM</label>
            <b-form-input type="text" placeholder="NCM" v-model="row.ncm">
            </b-form-input>
          </b-col>
          <b-col style="padding: 0">
            <label>CFOP</label>
            <b-form-input type="text" placeholder="CFOP" v-model="row.cfop">
            </b-form-input>
          </b-col>
          <b-col style="padding: 0">
            <label>Unidade Comerical</label>
            <b-form-input
              type="text"
              placeholder="Unidade Comerical"
              v-model="row.unidade_comercial"
            >
            </b-form-input>
          </b-col>
          <b-col style="padding: 0">
            <label>Quantidade</label>
            <b-form-input
              type="text"
              placeholder="Quantidade"
              v-model="row.qtd_comercial"
            >
            </b-form-input>
          </b-col>
          <!-- <b-col>
          <label>Peso</label>
           <currency-input
                class="form-control"
                v-model="row.peso"
                :precision="3"
                :locale="getCurrency.locale"
                style="text-align: right"
                :currency="{ prefix: 'KG '}"
                :distraction-free="getCurrency"/>
        </b-col> -->
          <b-col style="padding: 0">
            <label>Valor Unitário</label>
            <b-form-input
              type="text"
              placeholder="Valor Unitário"
              v-model="row.vlr_unitario"
            >
            </b-form-input>
          </b-col>
          <!-- <b-col>
          <label>Valor Toral</label>
          <b-form-input
            type="text"
            placeholder="Valor Toral"
            v-model="row.valor_total">
          </b-form-input>
        </b-col> -->
        </div>
      </b-container>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import moment from "moment";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      isFullscreen: false,
      errors_array: [],
      optionsLivTpPessoa: [],
      optionsMunicipios: [],
      optionsUf: [],
      optionsLivDocFiscalTpDoc: [],
      emiMunicipioSelected: [],
      desMunicipioSelected: [],
      redMunicipioSelected: [],
      tomMunicipioSelected: [],
      emiUfSelected: [],
      desUfSelected: [],
      redUfSelected: [],
      tomUfSelected: [],
      modalidadeSelected: [],
      tipoCargaSelected: [],
      tpDocSelected: [],
      item: [],
      mascaraEmiNfe: "###.###.###-##",
      mascaraDesNfe: "###.###.###-##",
      mascaraRedNfe: "###.###.###-##",
      mascaraTomNfe: "###.###.###-##",
      mascaraDesCte: "###.###.###-##",
      loadingCepEmi: false,
      loadingCepDes: false,
      loadingAddDoc: false,
      helpForm: new Form({
        modalidade_frete: "",
        tipo_carga: "",
        docfis_id: "",
        statusRecord: [],
        bcliente_id_active: "",
        params: [],
        search: "",
        docs: [],
        tp_doc: [],
        num_fiscal: "",
        num_lote: "",
        serie: "",
        chave: "",
        dt_emissao: "",
        qtd_volume: "",
        peso_bruto: 0,
        vlr_total_nfe: 0,
        emi_tp_pessoa: 1,
        emi_cnpj_cpf_cuit: "",
        emi_ie: "",
        emi_nome: "",
        emi_cep: "",
        emi_numero: "",
        emi_bairro: "",
        emi_endereco: "",
        emi_municipio: [],
        emi_uf: [],
        emi_complemento: "",
        des_tp_pessoa: 1,
        des_cnpj_cpf_cuit: "",
        des_ie: "",
        des_nome: "",
        des_cep: "",
        des_numero: "",
        des_bairro: "",
        des_endereco: "",
        des_municipio: [],
        des_uf: [],
        des_complemento: "",
        des_pin: "",
        cep_busca: "",
        globalizado: 2,
        red_tp_pessoa: 1,
        red_cnpj_cpf_cuit: "",
        red_ie: "",
        red_nome: "",
        red_pin: "",
        red_cep: "",
        red_municipio: [],
        red_uf: [],
        red_endereco: "",
        red_numero: "",
        red_bairro: "",
        red_complemento: "",
        tom_tp_pessoa: 1,
        tom_cnpj_cpf_cuit: "",
        tom_ie: "",
        tom_nome: "",
        tom_cep: "",
        tom_numero: "",
        tom_bairro: "",
        tom_endereco: "",
        tom_municipio: [],
        tom_uf: [],
        tom_complemento: "",
        tom_pin: "",
        item: [
          {
            docfispro_id: "",
            // num_item: 1,
            cd_produto: "",
            desc: "",
            ncm: "",
            cfop: "",
            unidade_comercial: "",
            qtd_comercial: "",
            // peso: '',
            vlr_unitario: 0,
            status: 1,
            // valor_total: '',
          },
        ],
      }),
      form: new Form({
        cd: "",
      }),

      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    tpDocSelected(obj) {
      this.helpForm.tp_doc = obj.value;
    },
    emiMunicipioSelected(obj) {
      this.helpForm.emi_municipio = obj.value;
    },
    desMunicipioSelected(obj) {
      this.helpForm.des_municipio = obj.value;
    },
    redMunicipioSelected(obj) {
      this.helpForm.red_municipio = obj.value;
    },
    tomMunicipioSelected(obj) {
      this.helpForm.tom_municipio = obj.value;
    },
    emiUfSelected(obj) {
      this.helpForm.emi_uf = obj.label;
    },
    desUfSelected(obj) {
      this.helpForm.des_uf = obj.label;
    },
    redUfSelected(obj) {
      this.helpForm.red_uf = obj.label;
    },
    tomUfSelected(obj) {
      this.helpForm.tom_uf = obj.label;
    },
    modalidadeSelected(obj) {
      this.helpForm.modalidade_frete = obj.value;
    },
    tipoCargaSelected(obj) {
      this.helpForm.tipo_carga = obj.value;
    },
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.helpForm.docfis_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.item = [];
      this.tpDocSelected = [];
      this.errors_array = [];
      this.modalidadeSelected = [];
      this.tipoCargaSelected = [];
      this.emiMunicipioSelected = [];
      this.desMunicipioSelected = [];
      this.redMunicipioSelected = [];
      this.tomMunicipioSelected = [];
      this.emiUfSelected = [];
      this.desUfSelected = [];
      this.redUfSelected = [];
      this.tomUfSelected = [];
      this.helpForm.reset();
      this.helpForm.vlr_unitario = parseFloat(this.helpForm.vlr_unitario);
      this.helpForm.peso_bruto = parseFloat(this.helpForm.peso_bruto);
      this.helpForm.vlr_total_nfe = parseFloat(this.helpForm.vlr_total_nfe);
      this.addRow();
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.item = [];
      this.errors_array = [];
      this.tpDocSelected = [];
      this.modalidadeSelected = [];
      this.tipoCargaSelected = [];
      this.emiMunicipioSelected = [];
      this.desMunicipioSelected = [];
      this.redMunicipioSelected = [];
      this.tomMunicipioSelected = [];
      this.emiUfSelected = [];
      this.desUfSelected = [];
      this.redUfSelected = [];
      this.tomUfSelected = [];
      this.helpForm.reset();
      this.helpForm.docfis_id = data.docfis_id;
      this.qtd_volume_total = 0;
      this.peso_bruto_total = 0;
      this.tpDocSelected = [];
      this.tpDocSelected = {
        label: data.liv_tp_doc.descr,
        value: data.liv_tp_doc.valor,
      };
      this.modalidadeSelected = {
        label: data.doc_fiscal_transporte.modalidade_frete.descr,
        value: data.doc_fiscal_transporte.modalidade_frete.valor,
      };
      this.tipoCargaSelected = {
        label: data.tipo_carga.descr,
        value: data.tipo_carga.tpcarga_id,
      };
      this.helpForm.num_fiscal = data.num_fiscal;
      this.helpForm.num_lote = data.num_lote;
      this.helpForm.serie = data.serie;
      this.helpForm.chave = data.chave;
      this.helpForm.dt_emissao = this.formatDateSubmit(data.dt_emissao);

      data.doc_fiscal_transporte.doc_fiscal_transporte_volume.forEach((obj) => {
        this.qtd_volume_total = obj.qtd_volume + this.qtd_volume_total;
        this.peso_bruto_total = obj.peso_bruto + this.peso_bruto_total;
      });
      this.helpForm.qtd_volume = this.qtd_volume_total;
      this.helpForm.peso_bruto = this.peso_bruto_total.toFixed(3);
      this.helpForm.vlr_total_nfe = data.doc_fiscal_vlr_total.vlr_total_nfe;

      //Emitente

      // this.helpForm.emi_tp_pessoa = data.doc_fiscal_partes_env.emi_tp_pessoa.value;
      this.helpForm.emi_cnpj_cpf_cuit =
        data.doc_fiscal_partes_env.emi_cnpj_cpf_cuit;
      this.helpForm.emi_ie = data.doc_fiscal_partes_env.emi_ie;
      this.helpForm.emi_nome = data.doc_fiscal_partes_env.emi_nome;
      this.helpForm.emi_cep = data.doc_fiscal_partes_env.emi_cep;
      if (data.doc_fiscal_partes_env.emi_municipio != null){
        this.emiMunicipioSelected = {
          label: data.doc_fiscal_partes_env.emi_municipio.nome,
          value: data.doc_fiscal_partes_env.emi_municipio.municipio_id,
        };
      }
      if (data.doc_fiscal_partes_env.emi_uf != null){
        this.emiUfSelected = {
          label: data.doc_fiscal_partes_env.emi_uf.cd,
          value: data.doc_fiscal_partes_env.emi_uf.uf_id,
        };
      }
      this.helpForm.emi_endereco = data.doc_fiscal_partes_env.emi_endereco;
      this.helpForm.emi_numero = data.doc_fiscal_partes_env.emi_numero;
      this.helpForm.emi_bairro = data.doc_fiscal_partes_env.emi_bairro;
      this.helpForm.emi_complemento =
        data.doc_fiscal_partes_env.emi_complemento != null
          ? data.doc_fiscal_partes_env.emi_complemento
          : "Sem Complemento";

      if (data.doc_fiscal_partes_env.emi_cnpj != null) {
        this.helpForm.emi_tp_pessoa = 2;
        this.ajustaMascara(1, 1);
        this.helpForm.emi_cnpj_cpf_cuit = data.doc_fiscal_partes_env.emi_cnpj;
      }
      if (
        data.doc_fiscal_partes_env.emi_cpf != null &&
        data.doc_fiscal_partes_env.emi_cpf != ""
      ) {
        this.helpForm.emi_tp_pessoa = 1;
        this.ajustaMascara(1, 1);
        this.helpForm.emi_cnpj_cpf_cuit = data.doc_fiscal_partes_env.emi_cpf;
      }
      if (
        data.doc_fiscal_partes_env.emi_cpf == null &&
        data.doc_fiscal_partes_env.emi_cnpj == null &&
        data.doc_fiscal_partes_env.emi_cpf == ""
      ) {
        this.helpForm.emi_tp_pessoa = 3;
        this.ajustaMascara(1, 1);
      }

      //Destinatario

      // this.helpForm.emi_tp_pessoa = data.doc_fiscal_partes_env.emi_tp_pessoa.value;
      this.helpForm.des_cnpj_cpf_cuit =
        data.doc_fiscal_partes_env.des_cnpj_cpf_cuit;
      this.helpForm.des_ie = data.doc_fiscal_partes_env.des_ie;
      this.helpForm.des_nome = data.doc_fiscal_partes_env.des_nome;
      if (data.doc_fiscal_partes_env.des_insc_suframa != null) {
        this.helpForm.des_pin = data.doc_fiscal_partes_env.des_insc_suframa;
      }
      this.helpForm.des_pin =
        data.doc_fiscal_partes_env.des_insc_suframa != null
          ? data.doc_fiscal_partes_env.des_insc_suframa
          : "Sem PIN Suframa";
      this.helpForm.des_cep = data.doc_fiscal_partes_env.des_cep;
      if (data.doc_fiscal_partes_env.des_municipio != null) {
        this.desMunicipioSelected = {
          label: data.doc_fiscal_partes_env.des_municipio.nome,
          value: data.doc_fiscal_partes_env.des_municipio.municipio_id,
        };
      }
      if (data.doc_fiscal_partes_env.des_uf != null) {
        this.desUfSelected = {
          label: data.doc_fiscal_partes_env.des_uf.cd,
          value: data.doc_fiscal_partes_env.des_uf.uf_id,
        };
      }
      this.helpForm.des_endereco = data.doc_fiscal_partes_env.des_endereco;
      this.helpForm.des_numero = data.doc_fiscal_partes_env.des_numero;
      this.helpForm.des_bairro = data.doc_fiscal_partes_env.des_bairro;
      this.helpForm.des_complemento =
        data.doc_fiscal_partes_env.des_complemento != null
          ? data.doc_fiscal_partes_env.des_complemento
          : "Sem Complemento";
      if (data.doc_fiscal_partes_env.des_cnpj != null) {
        this.helpForm.des_tp_pessoa = 2;
        this.ajustaMascara(2, 1);
        this.helpForm.des_cnpj_cpf_cuit = data.doc_fiscal_partes_env.des_cnpj;
      }
      if (
        data.doc_fiscal_partes_env.des_cpf != null &&
        data.doc_fiscal_partes_env.des_cpf != ""
      ) {
        this.helpForm.des_tp_pessoa = 1;
        this.ajustaMascara(2, 1);
        this.helpForm.des_cnpj_cpf_cuit = data.doc_fiscal_partes_env.des_cpf;
      }
      if (
        data.doc_fiscal_partes_env.des_cpf == null &&
        data.doc_fiscal_partes_env.des_cnpj == null &&
        data.doc_fiscal_partes_env.des_cpf == ""
      ) {
        this.helpForm.des_tp_pessoa = 3;
        this.ajustaMascara(2, 1);
      }

      //Redespacho
      this.helpForm.red_ie = data.doc_fiscal_partes_env.red_ie;
      this.helpForm.red_nome = data.doc_fiscal_partes_env.red_nome;
      this.helpForm.red_cep = data.doc_fiscal_partes_env.red_cep;
      if (data.doc_fiscal_partes_env.red_municipio != null) {
        this.redMunicipioSelected = {
          label: data.doc_fiscal_partes_env.red_municipio.nome,
          value: data.doc_fiscal_partes_env.red_municipio.municipio_id,
        };
      }
      if (data.doc_fiscal_partes_env.red_uf != null) {
        this.redUfSelected = {
          label: data.doc_fiscal_partes_env.red_uf.cd,
          value: data.doc_fiscal_partes_env.red_uf.uf_id,
        };
      }
      this.helpForm.red_endereco = data.doc_fiscal_partes_env.red_endereco;
      this.helpForm.red_numero = data.doc_fiscal_partes_env.red_numero;
      this.helpForm.red_bairro = data.doc_fiscal_partes_env.red_bairro;
      this.helpForm.red_complemento =
        data.doc_fiscal_partes_env.red_complemento != null
          ? data.doc_fiscal_partes_env.red_complemento
          : "Sem Complemento";

      if (data.doc_fiscal_partes_env.red_cnpj != null) {
        this.helpForm.red_tp_pessoa = 2;
        this.ajustaMascara(3, 1);
        this.helpForm.red_cnpj_cpf_cuit = data.doc_fiscal_partes_env.red_cnpj;
      }
      if (
        data.doc_fiscal_partes_env.red_cpf != "" &&
        data.doc_fiscal_partes_env.red_cpf != null
      ) {
        this.helpForm.red_tp_pessoa = 1;
        this.ajustaMascara(3, 1);
        this.helpForm.red_cnpj_cpf_cuit = data.doc_fiscal_partes_env.red_cpf;
      }
      if (
        data.doc_fiscal_partes_env.red_cpf == "" &&
        data.doc_fiscal_partes_env.red_cnpj == null &&
        data.doc_fiscal_partes_env.red_cpf == null
      ) {
        this.helpForm.red_tp_pessoa = 3;
        this.ajustaMascara(3, 1);
      }
      //Tomador
      if (data.doc_fiscal_partes_env.tom_nome != null) {
        this.helpForm.modalidade_frete = "";
      }
      this.helpForm.tom_ie = data.doc_fiscal_partes_env.tom_ie;
      this.helpForm.tom_nome = data.doc_fiscal_partes_env.tom_nome;
      this.helpForm.tom_cep = data.doc_fiscal_partes_env.tom_cep;
      if (data.doc_fiscal_partes_env.tom_municipio != null) {
        this.tomMunicipioSelected = {
          label: data.doc_fiscal_partes_env.tom_municipio.nome,
          value: data.doc_fiscal_partes_env.tom_municipio.municipio_id,
        };
      }
      if (data.doc_fiscal_partes_env.tom_uf != null) {
        this.tomUfSelected = {
          label: data.doc_fiscal_partes_env.tom_uf.cd,
          value: data.doc_fiscal_partes_env.tom_uf.uf_id,
        };
      }
      this.helpForm.tom_endereco = data.doc_fiscal_partes_env.tom_endereco;
      this.helpForm.tom_numero = data.doc_fiscal_partes_env.tom_numero;
      this.helpForm.tom_bairro = data.doc_fiscal_partes_env.tom_bairro;
      this.helpForm.tom_complemento =
        data.doc_fiscal_partes_env.tom_complemento != null
          ? data.doc_fiscal_partes_env.tom_complemento
          : "Sem Complemento";

      if (data.doc_fiscal_partes_env.tom_cnpj != null) {
        this.helpForm.tom_tp_pessoa = 2;
        this.ajustaMascara(4, 1);
        this.helpForm.tom_cnpj_cpf_cuit = data.doc_fiscal_partes_env.tom_cnpj;
      }
      if (
        data.doc_fiscal_partes_env.tom_cpf != "" &&
        data.doc_fiscal_partes_env.tom_cpf != null
      ) {
        this.helpForm.tom_tp_pessoa = 1;
        this.ajustaMascara(4, 1);
        this.helpForm.tom_cnpj_cpf_cuit = data.doc_fiscal_partes_env.tom_cpf;
      }
      if (
        data.doc_fiscal_partes_env.tom_cpf == null &&
        data.doc_fiscal_partes_env.tom_cnpj == null &&
        data.doc_fiscal_partes_env.tom_cpf == ""
      ) {
        this.helpForm.tom_tp_pessoa = 3;
        this.ajustaMascara(2, 1);
      }

      //itens

      data.doc_fiscal_produto.forEach((obj) => {
        if (obj.status == 1) {
          this.item.push({
            docfispro_id: obj.docfispro_id,
            cd_produto: obj.cd_produto,
            ncm: obj.ncm,
            descr_produto: obj.descr_produto,
            cfop: obj.cfop,
            unidade_comercial: obj.unidade_comercial,
            qtd_comercial: obj.qtd_comercial,
            // peso: obj.,
            vlr_unitario: obj.vlr_unitario,
            // valor_total: obj.,
          });
        }
      });

      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.item = this.item;
      if (this.helpForm.emi_cnpj_cpf_cuit != null) {
        this.helpForm.emi_cnpj_cpf_cuit =
          this.helpForm.emi_cnpj_cpf_cuit.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      }
      if (this.helpForm.des_cnpj_cpf_cuit != null) {
        this.helpForm.des_cnpj_cpf_cuit =
          this.helpForm.des_cnpj_cpf_cuit.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      }
      if (this.helpForm.red_cnpj_cpf_cuit != null) {
        this.helpForm.red_cnpj_cpf_cuit =
          this.helpForm.red_cnpj_cpf_cuit.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      }
      if (this.helpForm.tom_cnpj_cpf_cuit != null) {
        this.helpForm.tom_cnpj_cpf_cuit =
          this.helpForm.tom_cnpj_cpf_cuit.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      }
      if (this.helpForm.emi_cep != null) {
        this.helpForm.emi_cep = this.helpForm.emi_cep.replace(/([-./])/g, "");
      }
      if (this.helpForm.des_cep != null) {
        this.helpForm.des_cep = this.helpForm.des_cep.replace(/([-./])/g, "");
      }
      if (this.helpForm.red_cep != null) {
        this.helpForm.red_cep = this.helpForm.red_cep.replace(/([-./])/g, "");
      }
      if (this.helpForm.tom_cep != null) {
        this.helpForm.tom_cep = this.helpForm.tom_cep.replace(/([-./])/g, "");
      }
      this.helpForm
        .post("/api/docfiscal/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.item = this.item;
      if (this.helpForm.emi_cnpj_cpf_cuit != null) {
        this.helpForm.emi_cnpj_cpf_cuit =
          this.helpForm.emi_cnpj_cpf_cuit.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      }
      if (this.helpForm.des_cnpj_cpf_cuit != null) {
        this.helpForm.des_cnpj_cpf_cuit =
          this.helpForm.des_cnpj_cpf_cuit.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      }
      if (this.helpForm.red_cnpj_cpf_cuit != null) {
        this.helpForm.red_cnpj_cpf_cuit =
          this.helpForm.red_cnpj_cpf_cuit.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      }
      if (this.helpForm.tom_cnpj_cpf_cuit != null) {
        this.helpForm.tom_cnpj_cpf_cuit =
          this.helpForm.tom_cnpj_cpf_cuit.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      }
      if (this.helpForm.emi_cep != null) {
        this.helpForm.emi_cep = this.helpForm.emi_cep.replace(/([-./])/g, "");
      }
      if (this.helpForm.des_cep != null) {
        this.helpForm.des_cep = this.helpForm.des_cep.replace(/([-./])/g, "");
      }
      if (this.helpForm.red_cep != null) {
        this.helpForm.red_cep = this.helpForm.red_cep.replace(/([-./])/g, "");
      }
      if (this.helpForm.tom_cep != null) {
        this.helpForm.tom_cep = this.helpForm.tom_cep.replace(/([-./])/g, "");
      }
      this.helpForm
        .patch("/api/docfiscal/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    ajustaMascara(tipo, origem) {
      //Valor, destinatario/emitente, nfe/cte
      if (origem == 1) {
        //NFE
        if (tipo == 1) {
          //Emitente
          if (this.helpForm.emi_tp_pessoa == 1) {
            //PF
            this.mascaraEmiNfe = "###.###.###-##";
          }
          if (this.helpForm.emi_tp_pessoa == 2) {
            //PJ
            this.mascaraEmiNfe = "XX.XXX.XXX/XXXX-XX";
          }
          if (this.helpForm.emi_tp_pessoa == 3) {
            //PO
            this.mascaraEmiNfe = "XXXXXXXXXXXXXXXX";
          }
        }
        if (tipo == 2) {
          //Destinatario
          if (this.helpForm.des_tp_pessoa == 1) {
            //PF
            this.mascaraDesNfe = "###.###.###-##";
          }
          if (this.helpForm.des_tp_pessoa == 2) {
            //PJ
            this.mascaraDesNfe = "XX.XXX.XXX/XXXX-XX";
          }
          if (this.helpForm.des_tp_pessoa == 3) {
            //PO
            this.mascaraDesNfe = "XXXXXXXXXXXXXXXX";
          }
        }
        if (tipo == 3) {
          //Redespacho
          if (this.helpForm.red_tp_pessoa == 1) {
            //PF
            this.mascaraRedNfe = "###.###.###-##";
          }
          if (this.helpForm.red_tp_pessoa == 2) {
            //PJ
            this.mascaraRedNfe = "XX.XXX.XXX/XXXX-XX";
          }
          if (this.helpForm.red_tp_pessoa == 3) {
            //PO
            this.mascaraRedNfe = "XXXXXXXXXXXXXXXX";
          }
        }
        if (tipo == 4) {
          //Tomador
          if (this.helpForm.tom_tp_pessoa == 1) {
            //PF
            this.mascaraTomNfe = "###.###.###-##";
          }
          if (this.helpForm.tom_tp_pessoa == 2) {
            //PJ
            this.mascaraTomNfe = "XX.XXX.XXX/XXXX-XX";
          }
          if (this.helpForm.tom_tp_pessoa == 3) {
            //PO
            this.mascaraTomNfe = "XXXXXXXXXXXXXXXX";
          }
        }
      }
      if (origem == 2) {
        //CTE
        if (tipo == 2) {
          //Destinatario
          if (this.helpForm.des_tp_pessoa == 1) {
            //PF
            this.mascaraDesCte = "###.###.###-##";
          }
          if (this.helpForm.des_tp_pessoa == 2) {
            //PJ
            this.mascaraDesCte = "XX.XXX.XXX/XXXX-XX";
          }
          if (this.helpForm.des_tp_pessoa == 3) {
            //PO
            this.mascaraDesCte = "XXXXXXXXXXXXXXXX";
          }
        }
      }
    },
    sanitizeDocPessoa(value) {
      if (value == null) {
        return "";
      }

      return value
        .toString()
        .replace(/[^a-zA-Z0-9]/g, "")
        .toUpperCase();
    },
    addRow: function (num_item) {
      this.item.push({
        num_item: num_item + 1,
        cd_produto: "",
        descr_produto: "",
        ncm: "",
        cfop: "",
        unidade_comercial: "",
        qtd_comercial: "",
        peso: "",
        vlr_unitario: "",
        valor_total: "",
      });
    },
    removeRow: function (index_item) {
      this.item.splice(index_item, 1);
    },

    calcCte() {
      this.vn_vlr_cte = this.form.vlr_cte;
      this.vn_aliquota = this.form.vlr_aliquota;
      this.form.vlr_imposto = Number(
        this.vn_vlr_cte / ((100 - this.vn_aliquota) / 100) - this.vn_vlr_cte
      );
      this.vn_vlr_total = this.vn_vlr_cte + this.form.vlr_imposto;
      this.form.vlr_total = Number(this.vn_vlr_total);
    },
    getCep(index) {
      this.helpForm.cep_busca = this.helpForm.emi_cep.replace(/([-./])/g, "");
      //Nova variável "cep" somente com dígitos.
      var cep = this.helpForm.cep_busca.replace(/([-./])/g, "");
      //Verifica se campo cep possui valor informado.
      if (cep != "") {
        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          this.helpForm
            .post("/api/cep/pesquisar")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);

              this.helpForm.errors.clear();
              response.forEach((obj) => {
                this.helpForm.emi_endereco = obj.logradouro;
                this.helpForm.emi_bairro = obj.bairro;
                this.$parent.optionsMunicipios.forEach((obj2) => {
                  if (obj2.ibge == obj.ibge) {
                    this.emiMunicipioSelected = {
                      label: obj2.label,
                      value: obj2.value,
                    };
                  }
                });
              });
              this.loadingCep = false;
            })
            .catch((errors) => {
              this.loadingCep = false;
              new ReturnApi(errors, this);
            });
        } else {
          var errors = {
            errors: {
              emi_cep: ["Cep inválido"],
            },
          };
          this.helpForm.errors.record(errors.errors);
        }
      }
    },
    getCepDes(index) {
      this.helpForm.cep_busca = this.helpForm.des_cep.replace(/([-./])/g, "");
      //Nova variável "cep" somente com dígitos.
      var cep = this.helpForm.cep_busca.replace(/\D/g, "");
      //Verifica se campo cep possui valor informado.
      if (cep != "") {
        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          this.helpForm
            .post("/api/cep/pesquisar")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);

              this.helpForm.errors.clear();
              response.forEach((obj) => {
                this.helpForm.des_endereco = obj.logradouro;
                this.helpForm.des_bairro = obj.bairro;
                this.$parent.optionsMunicipios.forEach((obj2) => {
                  if (obj2.ibge == obj.ibge) {
                    this.desMunicipioSelected = {
                      label: obj2.label,
                      value: obj2.value,
                    };
                  }
                });
              });
              this.loadingCep = false;
            })
            .catch((errors) => {
              this.loadingCep = false;
              new ReturnApi(errors, this);
            });
        } else {
          var errors = {
            errors: {
              des_cep: ["Cep inválido"],
            },
          };
          this.helpForm.errors.record(errors.errors);
        }
      }
    },
    getCepRed(index) {
      this.helpForm.cep_busca = this.helpForm.red_cep.replace(/([-./])/g, "");
      //Nova variável "cep" somente com dígitos.
      var cep = this.helpForm.cep_busca.replace(/\D/g, "");
      //Verifica se campo cep possui valor informado.
      if (cep != "") {
        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          this.helpForm
            .post("/api/cep/pesquisar")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);

              this.helpForm.errors.clear();
              response.forEach((obj) => {
                this.helpForm.red_endereco = obj.logradouro;
                this.helpForm.red_bairro = obj.bairro;
                this.$parent.optionsMunicipios.forEach((obj2) => {
                  if (obj2.ibge == obj.ibge) {
                    this.redMunicipioSelected = {
                      label: obj2.label,
                      value: obj2.value,
                    };
                  }
                });
              });
              this.loadingCep = false;
            })
            .catch((errors) => {
              this.loadingCep = false;
              new ReturnApi(errors, this);
            });
        } else {
          var errors = {
            errors: {
              red_cep: ["Cep inválido"],
            },
          };
          this.helpForm.errors.record(errors.errors);
        }
      }
    },
    getCepTom(index) {
      this.helpForm.cep_busca = this.helpForm.tom_cep.replace(/([-./])/g, "");
      //Nova variável "cep" somente com dígitos.
      var cep = this.helpForm.cep_busca.replace(/\D/g, "");
      //Verifica se campo cep possui valor informado.
      if (cep != "") {
        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          this.helpForm
            .post("/api/cep/pesquisar")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);

              this.helpForm.errors.clear();
              response.forEach((obj) => {
                this.helpForm.tom_endereco = obj.logradouro;
                this.helpForm.tom_bairro = obj.bairro;
                this.$parent.optionsMunicipios.forEach((obj2) => {
                  if (obj2.ibge == obj.ibge) {
                    this.tomMunicipioSelected = {
                      label: obj2.label,
                      value: obj2.value,
                    };
                  }
                });
              });
              this.loadingCep = false;
            })
            .catch((errors) => {
              this.loadingCep = false;
              new ReturnApi(errors, this);
            });
        } else {
          var errors = {
            errors: {
              tom_cep: ["Cep inválido"],
            },
          };
          this.helpForm.errors.record(errors.errors);
        }
      }
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/unidade/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
